Bacon = require 'baconjs'

window.simulateErrors = false
window.simulateErrorCode = 500

wrapRequest = (promise, log) ->
  new Promise (resolve, reject) ->
    promise
      .then (data) ->
        if simulateErrors
          reject { success: false, status: { code: simulateErrorCode, message: 'simulated crash boom bang!' } }
        else if data.success
          resolve data
        else
          reject data
      , (data) ->
        reject { success: false, status: { code: 503, message: 'connection timeout'} }

wrapRequestJSON = (promise, log) ->
  # res = $.Deferred()
  # promise.then (data) -> res.resolve data
  # , (data) -> res.reject data
  # res
  # promise.then (response) -> response.json()
  new Promise (resolve, reject) ->
    promise.then resolve, reject

wrapWithRetry = (apiCall, delay = 300) ->
  Bacon
    .retry
      source: ->
        Bacon.fromPromise apiCall()
      retries: 5
      isRetryable: (data) -> data.status.code != 500
      delay: (ctx) ->
        delay * ctx.retriesDone

module.exports =
  wrapRequest: wrapRequest
  wrapRequestJSON: wrapRequestJSON
  wrapWithRetry: wrapWithRetry
